export const FeatureFlags = {
  AIAssistant: 'aiAssistant',
  AIAssistantSelectModels: 'aiAssistantSelectModels',
  AIGeneratorsIndustryBriefing: 'aiGeneratorsIndustryBriefing',
  AIGeneratorsLinkedinAIPrompt: 'aiGeneratorsLinkedinAIPrompt',
  AIPresentationMakerBulk: 'aiPresentationMakerBulk',
  AIPresentationMakerV2Endpoints: 'aiPresentationMakerV2Endpoints',
  AIProspectingAssistant: 'aiProspectingAssistant',
  AIRoleplay: 'aiRoleplay',
  AIRoleplayCreationFromList: 'aiRoleplayCreationFromList',
  ActivityDrawerInTablesCC: 'activityDrawerInTablesCC',
  ActivityOutcomeFieldsInForm: 'activityOutcomeFieldsInForm',
  AssitantRegionalDirectorsOnBehalfSendoutCreation:
    'assitantRegionalDirectorsOnBehalfSendoutCreation',
  AssociatedCompaniesTree: 'associatedCompaniesTree',
  BulkEmailAI: 'bulkEmailAI',
  BulkEmailAIRecruiting: 'bulkEmailAIRecruiting',
  BulkEmailListItemCardAILabel: 'AILabelOnBulkEmailItemCards',
  BulkEmailNewDashboardStats: 'newBulkDashboardStats',
  BulkEmailSequences: 'bulkEmailSequences',
  BulkShowEmailVariant: 'bulkShowEmailVariant',
  BulkSmartTagOnEmailBody: 'smartTagOnEmailBody',
  BulkSmartTagOnSubject: 'smartTagOnSubject',
  BulkStatsTablesActions: 'bulkStatsTablesActions',
  CandidateMatchMaking: 'candidateMatchMaking',
  CandidateMatchMakingByContact: 'candidateMatchMakingByContact',
  CandidateMatchMakingByJobOrder: 'candidateMatchMakingByJobOrder',
  CandidatesKeywordsFromApplicantUrl: 'candidatesKeywordsFromApplicantUrl',
  CandidatesMultiplePhones: 'candidatesMultiplePhones',
  CandidatesPresentationMaker: 'candidatesPresentationMaker',
  CandidatesSearchAccuracy: 'candidatesSearchAccuracy',
  CandidatesSavedSearches: 'candidatesSavedSearches',
  CandidatesTabMultiplePhones: 'candidatesTabMultiplePhones',
  CategoryFilesSendout: 'categoryFilesSendout',
  CategoryFilesSendoutDebrief: 'categoryFilesSendoutDebrief',
  ClaimAccountabilityCandidate: 'claimAccountabilityCandidate',
  ClaimAccountabilityCompany: 'claimAccountabilityCompany',
  ClaimAccountabilityJobOrder: 'claimAccountabilityJobOrder',
  CommandCenterCommissionsBoard: 'commandCenterCommissionsBoard',
  CommandCenterDominateActiveTab: 'commandCenterDominateActiveTab',
  CommandCenterDominateEstimatedCommissions: 'commandCenterDominateEstimatedCommissions',
  CommandCenterDrillDown: 'commandCenterDrillDown',
  CommandCenterFallOffsBoard: 'commandCenterFallOffsBoard',
  CommandCenterPDA: 'commandCenterPDA',
  CommandCenterProductionBoardPage: 'commandCenterProductionBoardPage',
  CommandCenterProductionBoardTracking: 'commandCenterProductionBoardTracking',
  CommandCenterShowVerification: 'commandCenterShowVerification',
  CommandCenterTrackingCashIn: 'commandCenterTrackingCashIn',
  CompaniesHeadquarterColumn: 'companiesHeadquarterColumn',
  CompaniesMultiplePhones: 'companiesMultiplePhones',
  CompaniesSalesTab: 'companiesSalesTab',
  CompaniesSavedSearches: 'companiesSavedSearches',
  CompaniesTargetPriority: 'companiesTargetPriority',
  ContactsDataSheetTab: 'contactsDataSheetTab',
  ContactsMultiplePhones: 'contactsMultiplePhones',
  ContactsSavedSearches: 'contactsSavedSearches',
  ConvertLegacyPhones: 'convertLegacyPhones',
  ConvertedContacts: 'redirectConvertedContacts',
  DailyPlan: 'dailyPlan',
  DailyPlanAddTaskFromProfile: 'dailyPlanAddTaskFromProfile',
  DailyPlanAddTasksFromTable: 'dailyPlanAddTasksFromTable',
  DailyPlanArchiveTasks: 'dailyPlanArchiveTasks',
  DailyPlanBulkReschedule: 'dailyPlanBulkReschedule',
  DashboardFeeAgreements: 'dashboardFA',
  DashboardSendoutLeaders: 'dashboardsendoutleaders',
  DashboardSendoutMetrics: 'dashboardsendoutmetrics',
  DashboardToolsUsageReport: 'dashboardtoolsusagereport',
  DashboardToolsUsageReportV2: 'dashboardtoolsusagereportV2',
  DarkMode: 'darkMode',
  Drafts: 'drafts',
  EmailValidationColumn: 'emailValidationColumn',
  EmailWithValidationColumnCandidates: 'emailWithValidationColumnCandidates',
  EmailWithValidationColumnNames: 'emailWithValidationColumnNames',
  EmailWithValidationColumnSearchProjectPreviews: 'emailWithValidationColumnSearchProjectPreviews',
  EmployeesMultiplePhones: 'employeesMultiplePhones',
  EnableRemoveInBulkTables: 'enableRemoveInBulkTables',
  ExpandableTables: 'expandableTables',
  ExternalFeeAgreement: 'externalFA',
  FeeAgreementsSplitPayments: 'fa-split-payments',
  FeedbackNotes: 'feedbackNotesDrawer',
  FeedbackNotesImagesSuport: 'feedbackNotesImagesSupport',
  FeedbackNotesSaveInEmployeeFile: 'feedbackNotesSaveInEmployeeFile',
  FilterByActivitiesInSearchProjects: 'filterByActivitiesInSearchProjects',
  FilterByBusinessInvolvement: 'filterByBusinessInvolvement',
  FilterByBusinessInvolvementSearchProjects: 'filterByBusinessInvolvementSearchProjects',
  FilterByCandidateAccountableOfHotSheet: 'filterByCandidateAccountableOfHotSheet',
  FilterByCandidateActivities: 'filterByCandidateActivities',
  FilterByCompanyActivities: 'filterByCompanyActivities',
  FilterByCompanyLegalName: 'filterByCompanyLegalName',
  FilterByContactActivities: 'filterByContactActivities',
  FilterByFeeAgreementPaymentScheme: 'filterByFeeAgreementPaymentScheme',
  FilterByJobOrderAccountableOfHotSheet: 'filterByJobOrderAccountableOfHotSheet',
  FilterByJobOrderActivities: 'filterByJobOrderActivities',
  FilterByLinkedInUrl: 'filterByLinkedInUrl',
  FilterByNumberOfContactsRange: 'filterByNumberOfContactsRange',
  FilterByNumberOfEmployeesRange: 'filterByNumberOfEmployeesRange',
  FilterByRevenueRange: 'filterByRevenueRange',
  FilterBySubStatus: 'filterBySubStatus',
  FollowUpTasks: 'followUpTasks',
  FreeGameButtons: 'FreeGameButtons',
  HaFeeAgreementTab: 'haFeeAgreementTab',
  HaJobOrderTab: 'haJobOrderTab',
  HaNameSubStatusEdition: 'haNameSubStatusEdition',
  HaPlacementsTab: 'haPlacementsTab',
  HiringAuthoritiesMultiplePhones: 'hiringAuthoritiesMultiplePhones',
  HiringExtendedLocationSearch: 'hiringExtendedLocationSearch',
  HomeMultipleRegions: 'homeMultipleRegions',
  IndustriesViewer: 'industriesViewer',
  IndustryEmailBCCSendout: 'industryEmailBCCSendout',
  InventoryListPersistDateRange: 'inventoryListPersistDateRange',
  InventoryProfilesV2: 'inventoryProfilesV2',
  JobOrderColumnMultipleHA: 'jobOrderColumnMultipleHA',
  JobOrderColumnsHAProfile: 'jobOrderColumnsHAProfile',
  JobOrderDataSheetFlow: 'jobOrderDataSheetFlow',
  JobOrderJobDescription: 'jobOrderJobDescription',
  JobOrderMatchMaking: 'jobOrderMatchMaking',
  JobOrderMatchMakingByApplicant: 'jobOrderMatchMakingByApplicant',
  JobOrderMatchMakingByCandidate: 'jobOrderMatchMakingByCandidate',
  JobOrderMatchMakingByContact: 'jobOrderMatchMakingByContact',
  JobOrderPresentationMaker: 'jobOrderPresentationMaker',
  JobOrderSavedSearches: 'jobOrderSavedSearches',
  KeywordPickerSplitByComma: 'keywordPickerSplitByComma',
  KeywordSearch: 'keywordsearch',
  LinkCompanies: 'linkCompanies',
  LogRocket: 'logrocket',
  MessageCenter: 'messageCenter',
  MessageCenterDrawerChat: 'messageCenterDrawerChat',
  MessageCenterFilters: 'messageCenterFilters',
  MessageCenterNotifications: 'messageCenterNotifications',
  MessageCenterSelectMessages: 'messageCenterSelectMessages',
  MessageCenterSendToUnsavedContact: 'messageCenterSendToUnsavedContact',
  MessageCenterTemplates: 'messageCenterTemplates',
  MultipleActivitiesFromList: 'multipleActivitiesFromList',
  MultipleKeywordsFromList: 'multipleKeywordsFromList',
  MultipleNotesFromList: 'multipleNotesFromList',
  MultiplePhonesColumn: 'multiplePhonesColumn',
  MultiplePhonesWithCommunicationActions: 'multiplePhonesWithCommunicationActions',
  MutiplePhonesListingTags: 'mutiplePhonesListingTags',
  NewCandidateFromContact: 'newCandidateFromContact',
  NewCandidateIncludesContactDataSheet: 'newCandidateIncludesContactDataSheet',
  NewCandidateTalentPoolValidation: 'newCandidateTalentPoolValidation',
  NewCandidateV2: 'newCandidateV2',
  NewHiringAuthorityTabs: 'newHiringAuthorityTabs',
  NewJobOrderV2: 'newJobOrderV2',
  NoHireLetter: 'noHireLetter',
  Notifications: 'notifications',
  OpenToRelocationFilter: 'openToRelocationFilter',
  OptOutFilter: 'optOutFilter',
  OtherEmailValidationProfiles: 'otherEmailValidationProfiles',
  PersonalEmailVerdictFilter: 'personalEmailVerdictFilter',
  PhoneDashboardTotalCalls: 'phoneDashboardTotalCalls',
  PilDescriptions: 'pilDescriptions',
  PlacementCollections: 'placement-collections',
  PlacementDeletePermanently: 'placementDeletePermanently',
  PlacementPaymentsFromNetsuite: 'placement-paymets-from-netsuite',
  PlacementRequestFeeOrGuaranteeChanges: 'placementRequestFeeOrGuaranteeChanges',
  PlacementSavedSearches: 'placementSavedSearches',
  PlacementWithAssignmentDataSheet: 'placement-data-sheet',
  PlacementWithReferences: 'placement-references',
  ProfileNavigationControls: 'profileNavigationControls',
  QuickEntry: 'quickEntry',
  ReferenceCheckAISummary: 'referenceCheckAISummary',
  ReferenceCheckDownload: 'referenceCheckDownload',
  RequestDoNotContactFromProfile: 'requestDoNotContactFromProfile',
  RequestDoNotEngageFromProfile: 'requestDoNotEngageFromProfile',
  ResendEmailHiringAuthoritySendout: 'resendEmailHiringAuthoritySendout',
  ResumeSearch: 'resumeSearch',
  SavedSearchesDate: 'savedSearchesDate',
  SearchProjectPreviewMultiplePhones: 'searchProjectPreviewMultiplePhones',
  SearchProjectsArchiveMultiple: 'archiveMultipleSearchProjects',
  SearchProjectsChangeOwner: 'changeSearchProjectOwner',
  SearchProjectsFolders: 'searchProjectsFolders',
  SearchProjectsMasterListFields: 'masterListFields',
  SendoutDuplicates: 'sendoutDuplicates',
  SendoutStatusReasonsFilter: 'sendoutStatusReasonsFilter',
  SendoutsV2: 'sendoutsV2',
  SendoutsChannelPartner: 'sendoutsChannelPartner',
  SendoutsInterviewDetailsActions: 'sendoutsInterviewDetailsActions',
  SendoutsSavedSearches: 'sendoutsSavedSearches',
  SendoverHAReminder: 'sendoverHAReminder',
  SharedSavedSearches: 'sharedSavedSearches',
  SigningBackupService: 'signingBackup',
  SpecificPILLocation: 'specificPILLocation',
  SupportActivity: 'supportActivity',
  TalentPoolLink: 'talentPoolLink',
  UrgencyVerification: 'urgencyVerification',
  UserDataByEndpoint: 'userDataByEndpoint',
  WebsiteFilter: 'websiteFilter'
};
